module.exports = __webpack_public_path__ + "static/tiamat_mtg_afr-ccf20ad54a349ba554e108a65fafa359.jpg";